import { useEffect, useState } from 'react';

// Оставшееся время до даты: { days, hours, minutes, seconds, isOver }
export const useCountdown = (targetDate) => {
  const target = targetDate ? new Date(targetDate).getTime() : null;
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!target) return;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [target]);

  const diff = target ? Math.max(0, target - now) : 0;
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    seconds: Math.floor((diff % 60000) / 1000),
    isOver: !!target && diff === 0,
  };
};
